import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Global Search
export const globalSearch = async (query, perType = 5) => {
  const response = await axios.get(`${API_URL}/api/search/global`, {
    params: { q: query, per_type: perType }
  });
  return response.data;
};

// Questions
export const searchQuestions = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/questions/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getQuestion = async (id) => {
  const response = await axios.get(`${API_URL}/api/questions/${id}`);
  return response.data;
};

// Parliamentarians
export const searchParliamentarians = async (query, page = 1, perPage = 25, sort = 'name_asc') => {
  const response = await axios.get(`${API_URL}/api/parliamentarians/search`, {
    params: { q: query, page, per_page: perPage, sort }
  });
  return response.data;
};

export const getParliamentarian = async (id) => {
  const response = await axios.get(`${API_URL}/api/parliamentarians/${id}`);
  return response.data;
};

export const getParliamentarianElections = async (phid) => {
  const response = await axios.get(`${API_URL}/api/parliamentarians/${phid}/elections`);
  return response.data;
};

// Committees
export const searchCommittees = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/committees/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getCommittee = async (id) => {
  const response = await axios.get(`${API_URL}/api/committees/${id}`);
  return response.data;
};

export const getCommitteeMembers = async (committeeId) => {
  const response = await axios.get(`${API_URL}/api/committees/${committeeId}/members`);
  return response.data;
};

// Electorates
export const searchElectorates = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/electorates/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getElectorate = async (id) => {
  const response = await axios.get(`${API_URL}/api/electorates/${id}`);
  return response.data;
};

export const getElectorateElections = async (eid) => {
  const response = await axios.get(`${API_URL}/api/electorates/${eid}/elections`);
  return response.data;
};

// Ministries
export const searchMinistries = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/ministries/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getMinistry = async (id) => {
  const response = await axios.get(`${API_URL}/api/ministries/${id}`);
  return response.data;
};

// Parliaments
export const searchParliaments = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/parliaments/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getParliament = async (id) => {
  const response = await axios.get(`${API_URL}/api/parliaments/${id}`);
  return response.data;
};

// Parties
// `active` (bool) and `chamber` ('Member' | 'Senator') are *derived* facets
// computed backend-side from the parliamentarians index (the parties
// corpus's own Active field is null across every doc). Omit either to skip
// that filter.
export const searchParties = async (query, page = 1, perPage = 25, opts = {}) => {
  const params = { q: query, page, per_page: perPage };
  if (opts.active !== undefined && opts.active !== null && opts.active !== '')
    params.active = opts.active;
  if (opts.chamber) params.chamber = opts.chamber;
  const response = await axios.get(`${API_URL}/api/parties/search`, { params });
  return response.data;
};

export const getParty = async (id) => {
  const response = await axios.get(`${API_URL}/api/parties/${id}`);
  return response.data;
};

export const getElections = async () => {
  const response = await axios.get(`${API_URL}/api/elections`);
  return response.data;
};

export const getElection = async (id) => {
  const response = await axios.get(`${API_URL}/api/elections/${id}`);
  return response.data;
};

export const getPartyMembers = async (pid) => {
  const response = await axios.get(`${API_URL}/api/parties/${pid}/members`);
  return response.data;
};

// States
export const searchStates = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/states/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getState = async (id) => {
  const response = await axios.get(`${API_URL}/api/states/${id}`);
  return response.data;
};

// Ministry Records
export const searchMinistryRecords = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/ministryrecords/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getMinistryRecord = async (id) => {
  const response = await axios.get(`${API_URL}/api/ministryrecords/${id}`);
  return response.data;
};

// Shadow Ministries
export const searchShadowMinistries = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/shadowministries/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getShadowMinistry = async (id) => {
  const response = await axios.get(`${API_URL}/api/shadowministries/${id}`);
  return response.data;
};

// Shadow Ministry Records
export const searchShadowMinistryRecords = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/shadowministryrecords/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getShadowMinistryRecord = async (id) => {
  const response = await axios.get(`${API_URL}/api/shadowministryrecords/${id}`);
  return response.data;
};

// Records of Service
export const searchRecordsOfService = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/recordsofservice/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getRecordOfService = async (id) => {
  const response = await axios.get(`${API_URL}/api/recordsofservice/${id}`);
  return response.data;
};

// Records of Service Types
export const searchRecordsOfServiceTypes = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/recordsofservicetype/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getRecordOfServiceType = async (id) => {
  const response = await axios.get(`${API_URL}/api/recordsofservicetype/${id}`);
  return response.data;
};

// Hansard
export const searchHansard = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null, era = null, sort = '_score', filters = {}) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (era) params.era = era;  // 'modern', 'historic', or null for all
  if (sort && sort !== '_score') params.sort = sort;
  // Dedicated, index-aware filter params (these actually work — unlike folding
  // these into the Lucene q string, which never matched: see #138-#142).
  const f = filters || {};
  if (f.chamber) params.chamber = f.chamber;
  if (f.party) params.party = f.party;
  if (f.speaker_name) params.speaker_name = f.speaker_name;
  // #162: ID-keyed speaker filter (PHID). Collapses a person's name variants
  // and links by PHID. speaker_name remains the free-text/name fallback.
  if (f.speaker_id) params.speaker_id = f.speaker_id;
  if (f.electorate) params.electorate = f.electorate;
  if (f.debate_type) params.debate_type = f.debate_type;
  if (f.parliament) params.parliament = f.parliament;
  if (f.date_from) params.date_from = f.date_from;
  if (f.date_to) params.date_to = f.date_to;
  // #276 — Federation Chamber discriminator. 'house_main' / 'federation_chamber'.
  // Only meaningful with chamber=house, but the backend will accept it either way.
  if (f.chamber_type) params.chamber_type = f.chamber_type;
  const response = await axios.get(`${API_URL}/api/hansard/search`, { params });
  return response.data;
};

// #162: canonical Hansard chamber filter options (House / Senate), sourced from
// the backend authority map — the single source of truth for both the dropdown
// and the query-time variant expansion. Also returns any uncovered raw
// spelling (drift safeguard).
export const getHansardChamberOptions = async () => {
  const response = await axios.get(`${API_URL}/api/hansard/chambers`);
  return response.data; // { options: [{id,label}], uncovered: [] }
};

// #162: PHID-grouped speaker autocomplete. Aggregates Hansard by speaker_id so
// each real person is one option (e.g. "Gillard" -> one 83L entry); the 10000
// collision sentinel and blank-PHID bucket are excluded server-side.
export const getHansardSpeakerSuggestions = async (q = '', limit = 15) => {
  const response = await axios.get(`${API_URL}/api/hansard/speakers/autocomplete`, {
    params: { q, limit },
  });
  return response.data; // { query, suggestions: [{phid, preferred_name, count}] }
};

export const submitFeedback = async (payload) => {
  const response = await axios.post(`${API_URL}/api/feedback`, payload);
  return response.data;
};

export const getSearchSuggestion = async (query, index = 'hansard') => {
  const response = await axios.get(`${API_URL}/api/suggest`, {
    params: { q: query, index },
  });
  return response.data; // { original, suggestion }
};

export const getNlQuery = async (query) => {
  const response = await axios.get(`${API_URL}/api/nl-query`, {
    params: { q: query },
  });
  return response.data; // { original, interpreted, lucene, applied }
};

export const getHansard = async (id) => {
  const response = await axios.get(`${API_URL}/api/hansard/${id}`);
  return response.data;
};

export const getHansardToc = async (tocId) => {
  const response = await axios.get(`${API_URL}/api/hansard/toc/${tocId}`);
  return response.data;
};

// ParlView video mapping (#92 Phase 1 — sitting-level "Watch on ParlView").
// Returns the day's video mapping for a chamber+date, or null when there's no
// mapping (e.g. Senate, pre-archive days, non-sitting days). Never throws on a
// 404 — the caller just hides the link.
export const getParlViewVideo = async (chamber, date) => {
  if (!chamber || !date) return null;
  try {
    const response = await axios.get(`${API_URL}/api/parlview/video`, {
      params: { chamber, date },
    });
    return response.data;
  } catch (err) {
    if (err.response && err.response.status === 404) return null;
    return null; // fail closed — never block the page on the optional link
  }
};

export const listHansardTocs = async (page = 1, perPage = 25, chamber = null, dateFrom = null, dateTo = null) => {
  const params = { page, per_page: perPage };
  if (chamber) params.chamber = chamber;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  const response = await axios.get(`${API_URL}/api/hansard/toc/list`, { params });
  return response.data;
};

// Constitution
export const searchConstitution = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/constitution/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getConstitutionProvision = async (id) => {
  const response = await axios.get(`${API_URL}/api/constitution/${id}`);
  return response.data;
};

// Australia Act
export const searchAustraliaAct = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/australiaact/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getAustraliaActProvision = async (id) => {
  const response = await axios.get(`${API_URL}/api/australiaact/${id}`);
  return response.data;
};

// Senate Questions on Notice
export const searchSenateQon = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null, sort = null) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  // #262: sort uses the `field:dir` shape (e.g. asked_date:desc) when not _score.
  if (sort && sort !== '_score') params.sort = sort;
  const response = await axios.get(`${API_URL}/api/senateqon/search`, { params });
  return response.data;
};

export const getSenateQon = async (id) => {
  const response = await axios.get(`${API_URL}/api/senateqon/${id}`);
  return response.data;
};

// Alias used by SenateQonDetail (#262); kept distinct from getSenateQon
// to preserve naming used elsewhere.
export const getSenateQonDetail = async (id) => {
  const response = await axios.get(`${API_URL}/api/senateqon/${id}`);
  return response.data;
};

// Notices of Motion
export const searchMotions = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  const response = await axios.get(`${API_URL}/api/motions/search`, { params });
  return response.data;
};

export const getMotion = async (id) => {
  const response = await axios.get(`${API_URL}/api/motions/${id}`);
  return response.data;
};

// Bills
export const searchBills = async (
  query,
  page = 1,
  perPage = 25,
  dateYear = null,
  dateMonth = null,
  sort = null,
  filters = {}
) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  // #251: sort uses the `field:dir` shape (e.g. last_updated:desc,
  // title.keyword:asc) — matches Hansard's pattern. Only send when set.
  if (sort) params.sort = sort;
  // #251: chamber filter (canonical id 'house'/'senate') expands at the
  // backend to every stored spelling via the authority map.
  const f = filters || {};
  if (f.chamber) params.chamber = f.chamber;
  const response = await axios.get(`${API_URL}/api/bills/search`, { params });
  return response.data;
};

// #251: canonical Bills chamber filter options (House / Senate). Sourced from
// the same authority map as Hansard so labels stay consistent across the app.
export const getBillsChamberOptions = async () => {
  const response = await axios.get(`${API_URL}/api/bills/chambers`);
  return response.data; // { options: [{id,label}] }
};

export const getBill = async (id) => {
  const response = await axios.get(`${API_URL}/api/bills/${id}`);
  return response.data;
};

// House Questions in Writing
export const searchHouseQiw = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null, sort = null) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (sort) params.sort = sort;
  const response = await axios.get(`${API_URL}/api/houseqiw/search`, { params });
  return response.data;
};

export const getHouseQiw = async (id) => {
  const response = await axios.get(`${API_URL}/api/houseqiw/${id}`);
  return response.data;
};

// Parliament Calendar
export const searchCalendar = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/calendar/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getCalendarEvent = async (id) => {
  const response = await axios.get(`${API_URL}/api/calendar/${id}`);
  return response.data;
};

// Tabled Documents
export const searchTabledDocuments = async (
  query,
  page = 1,
  perPage = 25,
  dateYear = null,
  dateMonth = null,
  sort = null,
  extraFilters = {},
) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (sort) params.sort = sort;
  // Pass through dedicated filter params (originating_chamber / paper_type /
  // author / is_disallowable / document_type / category / department /
  // parliament_number) — backend handles them as keyword term filters.
  Object.entries(extraFilters || {}).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') params[k] = v;
  });
  const response = await axios.get(`${API_URL}/api/tableddocuments/search`, { params });
  return response.data;
};

export const getTabledDocument = async (id) => {
  const response = await axios.get(`${API_URL}/api/tableddocuments/${id}`);
  return response.data;
};

// House of Representatives Divisions.
// `sort` takes the shared divisions vocabulary (date_desc | date_asc | _score);
// `passed` travels as its own param rather than inside `q` so the backend can
// compute the Result facet with its own filter excluded (corpus-wide facets).
export const searchDivisions = async (
  query, page = 1, perPage = 25, dateYear = null, dateMonth = null, sort = null, passed = null
) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (sort) params.sort = sort;
  if (passed !== null && passed !== undefined) params.passed = passed;
  const response = await axios.get(`${API_URL}/api/divisions/search`, { params });
  return response.data;
};

export const getDivision = async (id) => {
  const response = await axios.get(`${API_URL}/api/divisions/${id}`);
  return response.data;
};

// Notice Papers
export const searchNoticePapers = async (query, page = 1, perPage = 25, chamber = null, dateYear = null, dateMonth = null) => {
  const params = { q: query, page, per_page: perPage };
  if (chamber) params.chamber = chamber;
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  const response = await axios.get(`${API_URL}/api/noticepapers/search`, { params });
  return response.data;
};

export const getNoticePaper = async (id) => {
  const response = await axios.get(`${API_URL}/api/noticepapers/${id}`);
  return response.data;
};

export const getNoticePaperNavigation = async (id) => {
  const response = await axios.get(`${API_URL}/api/noticepapers/${id}/navigation`);
  return response.data;
};

// Standing Orders
export const searchStandingOrders = async (query, page = 1, perPage = 25, chapter = null) => {
  const params = { q: query, page, per_page: perPage };
  if (chapter !== null) params.chapter = chapter;
  const response = await axios.get(`${API_URL}/api/standingorders/search`, { params });
  return response.data;
};

export const getStandingOrder = async (id) => {
  const response = await axios.get(`${API_URL}/api/standingorders/${id}`);
  return response.data;
};

export const getStandingOrderByNumber = async (soNumber) => {
  const response = await axios.get(`${API_URL}/api/standingorders/by-number/${soNumber}`);
  return response.data;
};

export const getStandingOrdersToc = async () => {
  const response = await axios.get(`${API_URL}/api/standingorders/toc/list`);
  return response.data;
};

export const compareStandingOrders = async (leftSo, rightSo, leftChamber = 'hor', rightChamber = 'hor') => {
  const params = {
    left_so: leftSo,
    right_so: rightSo,
    left_chamber: leftChamber,
    right_chamber: rightChamber,
  };
  const response = await axios.get(`${API_URL}/api/standing-orders/compare`, { params });
  return response.data;
};

// Stats
export const getStats = async () => {
  const response = await axios.get(`${API_URL}/api/stats`);
  return response.data;
};

export const getOverviewStats = async () => {
  const response = await axios.get(`${API_URL}/api/stats/overview`);
  return response.data;
};

export const getSuggestions = async (field, prefix) => {
  const response = await axios.get(`${API_URL}/api/suggest`, {
    params: { field, prefix }
  });
  return response.data;
};

// Electorate Maps
export const searchElectorateMaps = async (query, page = 1, perPage = 25, electorate = null, eid = null) => {
  const params = { q: query, page, per_page: perPage };
  if (electorate) params.electorate = electorate;
  if (eid) params.eid = eid;
  const response = await axios.get(`${API_URL}/api/electorate-maps/search`, { params });
  return response.data;
};

export const getElectorateMapKml = async (mapId) => {
  const response = await axios.get(`${API_URL}/api/electorate-maps/kml/${mapId}`, {
    responseType: 'text'
  });
  return response.data;
};

export const getElectorateMapGeoJson = async (mapId, simplify = 0.001) => {
  const params = {};
  if (simplify) params.simplify = simplify;
  const response = await axios.get(`${API_URL}/api/electorate-maps/geojson/${mapId}`, { params });
  return response.data;
};

export const getElectorateMapsByYear = async (year, state = null) => {
  const params = {};
  if (state) params.state = state;
  const response = await axios.get(`${API_URL}/api/electorate-maps/by-year/${year}`, { params });
  return response.data;
};

export const getAvailableYears = async () => {
  const response = await axios.get(`${API_URL}/api/electorate-maps/available-years`);
  return response.data;
};

export const getGeoJsonByYear = async (year, state = null) => {
  const params = {};
  if (state) params.state = state;
  const response = await axios.get(`${API_URL}/api/electorate-maps/geojson-by-year/${year}`, { params });
  return response.data;
};

// Graph Visualization
export const getGraphSeed = async (limit = 100) => {
  const response = await axios.get(`${API_URL}/api/graph/seed`, {
    params: { limit }
  });
  return response.data;
};

export const expandGraphNode = async (nodeType, nodeId, limit = 50) => {
  const response = await axios.get(`${API_URL}/api/graph/node/${nodeType}/${encodeURIComponent(nodeId)}`, {
    params: { limit }
  });
  return response.data;
};

export const searchGraph = async (query, limit = 20) => {
  const response = await axios.get(`${API_URL}/api/graph/search`, {
    params: { q: query, limit }
  });
  return response.data;
};

// Senate Standing Orders
export const searchSenateStandingOrders = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/senate-standing-orders/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getSenateStandingOrder = async (soNumber) => {
  const response = await axios.get(`${API_URL}/api/senate-standing-orders/${soNumber}`);
  return response.data;
};

export const getSenateStandingOrdersToc = async () => {
  const response = await axios.get(`${API_URL}/api/senate-standing-orders/toc`);
  return response.data;
};

// House Practice
export const searchHousePractice = async (query, page = 1, perPage = 25) => {
  const response = await axios.get(`${API_URL}/api/house-practice/search`, {
    params: { q: query, page, per_page: perPage }
  });
  return response.data;
};

export const getHousePracticeProvision = async (id) => {
  const response = await axios.get(`${API_URL}/api/house-practice/${id}`);
  return response.data;
};

// Senate Divisions. Same sort vocabulary and same `passed` handling as the
// House endpoint above.
export const searchSenateDivisions = async (
  query, page = 1, perPage = 25, passed = null, dateYear = null, dateMonth = null, sort = null
) => {
  const params = { q: query, page, per_page: perPage };
  if (passed !== null && passed !== undefined) params.passed = passed;
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (sort) params.sort = sort;
  const response = await axios.get(`${API_URL}/api/senate-divisions/search`, { params });
  return response.data;
};

export const getSenateDivision = async (id) => {
  const response = await axios.get(`${API_URL}/api/senate-divisions/${id}`);
  return response.data;
};

// House Daily Program
export const searchHouseDailyProgram = async (query, page = 1, perPage = 25, year = null) => {
  const params = { q: query, page, per_page: perPage };
  if (year) params.year = year;
  const response = await axios.get(`${API_URL}/api/house-daily-program/search`, { params });
  return response.data;
};

export const getHouseDailyProgram = async (id) => {
  const response = await axios.get(`${API_URL}/api/house-daily-program/${id}`);
  return response.data;
};

// Senate Order of Business ("the Red")
export const searchSenateOrderOfBusiness = async (query, page = 1, perPage = 25, year = null) => {
  const params = { q: query, page, per_page: perPage };
  if (year) params.year = year;
  const response = await axios.get(`${API_URL}/api/senate-order-of-business/search`, { params });
  return response.data;
};

export const getSenateOrderOfBusiness = async (id) => {
  const response = await axios.get(`${API_URL}/api/senate-order-of-business/${id}`);
  return response.data;
};

// Senate Journals
export const searchSenateJournals = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  const response = await axios.get(`${API_URL}/api/senate-journals/search`, { params });
  return response.data;
};

export const getSenateJournal = async (id) => {
  const response = await axios.get(`${API_URL}/api/senate-journals/${id}`);
  return response.data;
};

export const getSenateJournalNavigation = async (id) => {
  const response = await axios.get(`${API_URL}/api/senate-journals/${id}/navigation`);
  return response.data;
};

// Votes and Proceedings
export const searchVotesProceedings = async (query, page = 1, perPage = 25, dateYear = null, dateMonth = null, dateDay = null, sort = null) => {
  const params = { q: query, page, per_page: perPage };
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (dateDay) params.date_day = dateDay;
  if (sort) params.sort = sort;
  const response = await axios.get(`${API_URL}/api/votes-proceedings/search`, { params });
  return response.data;
};

export const getVotesProceedings = async (id) => {
  const response = await axios.get(`${API_URL}/api/votes-proceedings/${id}`);
  return response.data;
};

export const getVotesProceedingsNavigation = async (id) => {
  const response = await axios.get(`${API_URL}/api/votes-proceedings/${id}/navigation`);
  return response.data;
};

// Live Minutes (draft running minutes, per-chamber per-sitting-day, with
// rich per-item timing metadata).
export const searchLiveMinutes = async (query, page = 1, perPage = 25, chamber = null, dateYear = null, dateMonth = null) => {
  const params = { q: query, page, per_page: perPage };
  if (chamber) params.chamber = chamber;
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  const response = await axios.get(`${API_URL}/api/live-minutes/search`, { params });
  return response.data;
};

export const getLiveMinutes = async (id) => {
  const response = await axios.get(`${API_URL}/api/live-minutes/${id}`);
  return response.data;
};

// House Questions (Question Time questions scraped from HouseLive — one doc
// per question per chamber per sitting day, with the asker, responder +
// portfolio, start time, and the full caption transcript of the question +
// answer).
export const searchHouseQuestions = async (
  query,
  page = 1,
  perPage = 25,
  chamber = null,
  asker = null,
  responder = null,
  portfolio = null,
  dateYear = null,
  dateMonth = null,
  dateDay = null,
  sort = null,
) => {
  const params = { q: query, page, per_page: perPage };
  if (chamber) params.chamber = chamber;
  if (asker) params.asker = asker;
  if (responder) params.responder = responder;
  if (portfolio) params.portfolio = portfolio;
  if (dateYear) params.date_year = dateYear;
  if (dateMonth) params.date_month = dateMonth;
  if (dateDay) params.date_day = dateDay;
  if (sort) params.sort = sort;
  const response = await axios.get(`${API_URL}/api/house-questions/search`, { params });
  return response.data;
};

export const getHouseQuestion = async (id) => {
  const response = await axios.get(`${API_URL}/api/house-questions/${encodeURIComponent(id)}`);
  return response.data;
};

// Committee Reports
export const searchCommitteeReports = async (query, page = 1, perPage = 25, committeeType = null, year = null) => {
  const params = { q: query, page, per_page: perPage };
  if (committeeType) params.committee_type = committeeType;
  if (year) params.year = year;
  const response = await axios.get(`${API_URL}/api/committee-reports/search`, { params });
  return response.data;
};

export const getCommitteeReport = async (id) => {
  const response = await axios.get(`${API_URL}/api/committee-reports/${encodeURIComponent(id)}`);
  return response.data;
};

// Petitions
export const searchPetitions = async (query, page = 1, perPage = 25, petitionType = null, status = null, year = null) => {
  const params = { q: query, page, per_page: perPage };
  if (petitionType) params.petition_type = petitionType;
  if (status) params.status = status;
  if (year) params.year = year;
  const response = await axios.get(`${API_URL}/api/petitions/search`, { params });
  return response.data;
};

export const getPetition = async (id) => {
  const response = await axios.get(`${API_URL}/api/petitions/${id}`);
  return response.data;
};

// CSV Export
export const exportCSV = async (dataType, query = '*', maxRecords = 10000) => {
  const response = await axios.get(`${API_URL}/api/${dataType}/export`, {
    params: { q: query, max_records: maxRecords },
    responseType: 'blob'
  });

  // Extract filename from Content-Disposition header or generate one
  const contentDisposition = response.headers['content-disposition'];
  let filename = `${dataType}_export.csv`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) filename = match[1];
  }

  // Create download link and trigger download
  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { success: true, filename };
};

// Download a single Hansard fragment as a PDF (triggers a browser download).
export const downloadHansardPdf = async (hansardId) => {
  const response = await axios.get(`${API_URL}/api/hansard/${hansardId}/pdf`, {
    responseType: 'blob'
  });

  const contentDisposition = response.headers['content-disposition'];
  let filename = `hansard-${hansardId}.pdf`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) filename = match[1];
  }

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { success: true, filename };
};

// Download the source XML for a Hansard record (triggers a browser download).
export const downloadHansardXml = async (hansardId) => {
  const response = await axios.get(`${API_URL}/api/hansard/${hansardId}/xml`, {
    responseType: 'blob'
  });

  const contentDisposition = response.headers['content-disposition'];
  let filename = `hansard-${hansardId}.xml`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) filename = match[1];
  }

  const blob = new Blob([response.data], { type: 'application/xml' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return { success: true, filename };
};

// Authenticated API instance for user-specific endpoints
// Automatically includes Bearer token from localStorage
const authenticatedApi = axios.create({
  baseURL: `${API_URL}/api`,
});

authenticatedApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('parlsearch_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Explore › Statistics (Handbook removed-functionality pages)
export const getExploreStat = async (slug, params = {}) => {
  const response = await axios.get(`${API_URL}/api/explore/stats/${slug}`, { params });
  return response.data;
};

// Feature requests (#101) — authenticated
export const submitFeatureRequest = async (payload) => {
  const response = await authenticatedApi.post('/feature-requests', payload);
  return response.data;
};

export const getMyFeatureRequests = async () => {
  const response = await authenticatedApi.get('/feature-requests');
  return response.data;
};

// Default export for authenticated API calls
export default authenticatedApi;
